var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "" } },
        [
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div1" }, [_vm._v("仓库管理")]),
          ]),
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "div2" }, [_vm._v("仓库调拨")]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tab", staticStyle: { "padding-bottom": "0" } },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待审核", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "驳回", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "已完成", name: "2" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "tab",
          staticStyle: {
            color: "#333",
            "font-wegin": "600",
            "margin-bottom": "10px",
            "margin-top": "10px",
            "border-radius": "0px 0px 10px 10px",
            "padding-top": "10px",
          },
        },
        [
          _vm._v(" 数据查询 "),
          _vm.activeName == 0
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form0, "label-width": "70px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单信息" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          placeholder: "请输入调整编号/商品信息",
                        },
                        model: {
                          value: _vm.form0.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.form0, "info", $$v)
                          },
                          expression: "form0.info",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请人" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form0.schedule,
                            callback: function ($$v) {
                              _vm.$set(_vm.form0, "schedule", $$v)
                            },
                            expression: "form0.schedule",
                          },
                        },
                        _vm._l(_vm.proposerList, function (item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          clearable: "",
                          type: "daterange",
                          size: "small",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerOptions,
                        },
                        model: {
                          value: _vm.form0.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form0, "date", $$v)
                          },
                          expression: "form0.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(0)
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.getList(0)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c("el-button", { attrs: { size: "mini" } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName == 1
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form1, "label-width": "70px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单信息" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          placeholder: "请输入调整编号/商品信息",
                        },
                        model: {
                          value: _vm.form1.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "info", $$v)
                          },
                          expression: "form1.info",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请人" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form1.schedule,
                            callback: function ($$v) {
                              _vm.$set(_vm.form1, "schedule", $$v)
                            },
                            expression: "form1.schedule",
                          },
                        },
                        _vm._l(_vm.proposerList, function (item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          clearable: "",
                          type: "daterange",
                          size: "small",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerOptions,
                        },
                        model: {
                          value: _vm.form1.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form1, "date", $$v)
                          },
                          expression: "form1.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(0)
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.getList(0)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c("el-button", { attrs: { size: "mini" } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.activeName == 2
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form2, "label-width": "70px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单信息" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          clearable: "",
                          placeholder: "请输入调整编号/商品信息",
                        },
                        model: {
                          value: _vm.form2.info,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "info", $$v)
                          },
                          expression: "form2.info",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请人" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "请选择",
                            "default-first-option": "",
                          },
                          model: {
                            value: _vm.form2.schedule,
                            callback: function ($$v) {
                              _vm.$set(_vm.form2, "schedule", $$v)
                            },
                            expression: "form2.schedule",
                          },
                        },
                        _vm._l(_vm.proposerList, function (item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.value, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "申请时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          clearable: "",
                          type: "daterange",
                          size: "small",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerOptions,
                        },
                        model: {
                          value: _vm.form2.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form2, "date", $$v)
                          },
                          expression: "form2.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(0)
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.getList(0)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c("el-button", { attrs: { size: "mini" } }, [
                        _vm._v("取消"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.activeName != 2
        ? _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _vm.parArray.indexOf("moreApproveCode") != -1 &&
              _vm.activeName != 1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.ratify },
                    },
                    [_vm._v("批量批准")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("moreBackCode") != -1 && _vm.activeName != 1
                ? _c(
                    "el-button",
                    { attrs: { size: "mini", type: "primary" } },
                    [_vm._v("批量驳回")]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("batchGuideCode") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.batchGuideOrder },
                    },
                    [_vm._v("批量导单")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "tableContext" },
        [
          _c(
            "el-table",
            {
              attrs: { data: _vm.table.list },
              on: {
                "row-click": function ($event) {
                  return _vm.detailClick($event.oddNumbers)
                },
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "index", width: "50", label: "序号" },
              }),
              _c("el-table-column", {
                attrs: { label: "调拨编号", prop: "oddNumbers" },
              }),
              _c("el-table-column", {
                attrs: { label: "进度", prop: "progressBar" },
              }),
              _c("el-table-column", {
                attrs: { label: "申请人", prop: "proposerName" },
              }),
              _c("el-table-column", {
                attrs: { label: "物流审核", prop: "updateBy" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.auditor.物流经理审批
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.auditor.物流经理审批) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        !scope.row.auditor.物流经理审批
                          ? _c("div", [_vm._v("--")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "申请时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.$moment(scope.row.createTime)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "buttons" }, [
                          scope.row.isApprove == 1 &&
                          _vm.activeName == 0 &&
                          _vm.parArray.indexOf("dshApproveCode") != -1 &&
                          scope.row.auditor["物流经理审批"] == "--"
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      ;(_vm.polliingType = 1),
                                        (_vm.textarea = ""),
                                        _vm.ratify(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("批准")]
                              )
                            : _vm._e(),
                          scope.row.isApprove == 1 &&
                          _vm.activeName == 0 &&
                          _vm.parArray.indexOf("dshBackCode") != -1 &&
                          scope.row.auditor["物流经理审批"] == "--"
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "#ff5656" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      ;(_vm.polliingType = 2),
                                        (_vm.dowith = true),
                                        (_vm.textarea = ""),
                                        (_vm.signPolliing = scope.row)
                                    },
                                  },
                                },
                                [_vm._v("驳回")]
                              )
                            : _vm._e(),
                          _vm.activeName == 1 &&
                          scope.row.isSelf == 1 &&
                          _vm.parArray.indexOf("againCode") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.update(scope.row.oddNumbers)
                                    },
                                  },
                                },
                                [_vm._v("重开")]
                              )
                            : _vm._e(),
                          _vm.parArray.indexOf("processCode") != -1
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.queryProcess(
                                        scope.row.procInstId
                                      )
                                    },
                                  },
                                },
                                [_vm._v("流程")]
                              )
                            : _vm._e(),
                          scope.row.proposer == _vm.userId &&
                          scope.row.isSelf == 1 &&
                          _vm.activeName != 2 &&
                          _vm.parArray.indexOf("backDeteledCode") != -1
                            ? _c(
                                "span",
                                {
                                  staticStyle: { color: "#ff5656" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.del(scope.row.oddNumbers)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            size: "50%",
            withHeader: false,
            "append-to-body": "",
            visible: _vm.drawer,
            "show-close": false,
            direction: "rtl",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("div", { staticClass: "drawerContext" }, [
            _c("div", { staticClass: "title" }, [
              _c("i", {
                staticClass: "el-icon-close",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    _vm.drawer = false
                  },
                },
              }),
              _c("span", { staticStyle: { "margin-left": "20px" } }, [
                _vm._v("库存调拨单详情"),
              ]),
            ]),
            _c("div", { staticClass: "left" }, [
              _c(
                "div",
                { staticClass: "tableBorder" },
                [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [
                      _vm._v("调拨编号：" + _vm._s(_vm.detail.oddNumbers)),
                    ]),
                    _c("span", [
                      _c("span", { staticStyle: { "margin-right": "20px" } }, [
                        _vm._v(
                          "申请人：" + _vm._s(_vm.detail.proposerName) + " "
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          " 创建时间：" +
                            _vm._s(_vm.$moment(_vm.detail.createdTime))
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.detail.goods } },
                    [
                      _c("el-table-column", {
                        attrs: { type: "index", width: "50", label: "序号" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品信息", prop: "goodsName" },
                      }),
                      _vm._l(_vm.wareList.list, function (item, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: { label: item.name },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.wars &&
                                    scope.row.wars.find(
                                      (res) => res.warId == item.id
                                    )
                                      ? _c("div", [
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.wars.find(
                                                    (res) =>
                                                      res.warId == item.id
                                                  ).laterQuantity
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  scope.row.wars.find(
                                                    (res) =>
                                                      res.warId == item.id
                                                  ).difference >= 0
                                                    ? "+" +
                                                        scope.row.wars.find(
                                                          (res) =>
                                                            res.warId == item.id
                                                        ).difference
                                                    : scope.row.wars.find(
                                                        (res) =>
                                                          res.warId == item.id
                                                      ).difference
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ])
                                      : _c("div", [
                                          _c("div", [_vm._v(_vm._s(0))]),
                                          _c("div", [_vm._v("+0")]),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      _c("el-table-column", {
                        attrs: { label: "调整原因", prop: "warAdName" },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "审核过程",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.polliing } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "步骤", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "任务节点",
                  prop: "taskName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: { label: "办理人", prop: "assignee", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批开始时间", prop: "startTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "审批结束时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.endTime
                          ? _c("span", [_vm._v(_vm._s(props.row.endTime))])
                          : _vm._e(),
                        !props.row.endTime
                          ? _c("span", [_vm._v("正在处理中...")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审批意见", "show-overflow-tooltip": true },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.comment
                          ? _c("span", [_vm._v(_vm._s(props.row.comment))])
                          : _vm._e(),
                        !props.row.comment
                          ? _c("span", [_vm._v("/")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dowith, "append-to-body": true, title: "办理" },
          on: {
            "update:visible": function ($event) {
              _vm.dowith = $event
            },
          },
        },
        [
          _c(
            "span",
            { staticStyle: { display: "inline-block", "line-height": "30px" } },
            [_vm._v("审批意见:")]
          ),
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请输入内容" },
            model: {
              value: _vm.textarea,
              callback: function ($$v) {
                _vm.textarea = $$v
              },
              expression: "textarea",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row-reverse",
                padding: "10px 0px",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.ratify(_vm.signPolliing)
                    },
                  },
                },
                [_vm._v("驳回")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "50px" } }),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.table.pageNo,
              "page-sizes": [10, 20, 50, 100, 200],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.table.totalPage,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }